module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.reMount
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Dina bokade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "people max-width"
  }, _vm._l((_vm.people), function(person, index) {
    return (person.guideCompleted) ? _c('div', {
      class: {
        person: true, opened: (_vm.currentIndex === index), completed: person.guideFullyCompleted
      }
    }, [_c('div', {
      staticClass: "blue-bar",
      on: {
        "click": function($event) {
          return _vm.setActive(_vm.currentIndex !== index ? index : -1)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "green-check",
        "scale": 1.8
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("Åkare " + _vm._s(index + 1) + ":")]), _vm._v(" "), (_vm.days(person.age).find(function(day) {
      return day.value === person.days
    })) ? _c('span', {
      staticClass: "package"
    }, [_vm._v("\n          " + _vm._s(_vm.days(person.age).find(function(day) {
      return day.value === person.days
    }).title) + " /\n          " + _vm._s(_vm.ages[person.age]) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_c('span', [_c('b', [_vm._v("Pris:")]), _vm._v(" " + _vm._s(_vm._f("currency")((person.price + (person.keycardPrice ? person.keycardPrice : 0)))))])]), _vm._v(" "), _c('span', {
      staticClass: "change",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setActive(index)
        }
      }
    }, [_c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(index)
        }
      }
    }, [_c('button', {
      staticClass: "small white tight"
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.2
      }
    })], 1)])])]), _vm._v(" "), (_vm.currentIndex !== index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          Visa\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-green",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          Stäng\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue-up",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue-up",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "animate-filter"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.currentIndex === index)),
        expression: "(currentIndex === index)"
      }],
      staticClass: "ski-pass-user-wrapper"
    }, [_c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      class: 'content'
    }, [_c('label', [_vm._v("Ålder")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.ages[person.age]) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])])]), _vm._v(" "), _c('div', {
      class: 'content ' + (person.age ? '' : 'disabled')
    }, [_c('label', [_vm._v("Antal dagar")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.days(person.age).find(function(day) {
      return day.value === person.days
    }).title) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])])]), _vm._v(" "), (person.refill) ? _c('div', {
      class: 'content'
    }, [_c('label', [_vm._v("Ditt keycardnummer")]), _vm._v(" "), (person.pass && person.pass.number) ? _c('div', [_vm._v("\n              " + _vm._s(person.pass.number) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])]) : _c('div', [_vm._v("\n              " + _vm._s(person.cardPrefix) + "-" + _vm._s(person.cardNumber) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])])]) : _vm._e()])])])], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "max-width align-right"
  }, [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "heading-products"
  }, [_vm._v("Sammanställning")]), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      Totalt:\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center button-confirm space-3 "
  }, [(_vm.nextIndex) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Gå vidare till nästa åkare")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    staticClass: "small white border big",
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.addPerson()
      }
    }
  }, [_vm._v("Lägg till ny åkare")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('span', {
    staticStyle: {
      "margin-left": "15px",
      "margin-right": "15px"
    }
  }, [_vm._v(" ... eller ... ")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.doSkipass()
      }
    }
  }, [_vm._v("Slutför bokning")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dda231f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiPass/SkiPassUserOverview.vue
// module id = 951
// module chunks = 0